import { useQuery } from '@tanstack/react-query';

import { OfficeDetailByCodeApiResponse } from '@src/lib/__generated/api';
import restfulClient from '@src/utils/restfulClient';

export async function fetchFacility({ facilityCode }) {
	const route = `v1/facilities/${facilityCode}`;
	try {
		const data: OfficeDetailByCodeApiResponse = await restfulClient.get({ route });
		return data;
	} catch (error) {
		if (error instanceof Error) {
			throw new Error(error.message);
		} else {
			throw new Error('Failed to fetch facility details');
		}
	}
}

export function useGetFacility({ facilityCode }) {
	const { error, isLoading, data } = useQuery<OfficeDetailByCodeApiResponse, Error>({
		queryKey: ['fetchFacility', { facilityCode }],
		queryFn: () => fetchFacility({ facilityCode }),
		enabled: !!facilityCode,
	});
	return { error, isLoading, data };
}
